<template>
  <div>
    <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit">
    <b-row class="toolbar-ptc">
      <b-col>
      </b-col>
      <b-col class="text-center title">系統管理 / Mail Server 管理</b-col>
      <b-col>
        <div class="text-right">
          <button type='button' class='btn btn-warning text-white' v-show='btn_edit' @click='btn_edit = !btn_edit'>修改</button>
          <button type="submit" class="btn btn-save" v-if='FunctionPermission > 1 && !btn_edit'>儲存</button>
          <button type="button" class="btn btn-clear" v-if='FunctionPermission > 1 && !btn_edit' @click="cancel">取消</button>
        </div>
      </b-col>
    </b-row>
    <div style="padding: 0.75rem">
        <validate tag="div">
        <b-form-group id="exampleInputGroup1"
                      label="伺服器名稱"
                      label-for="exampleInput1">
          <b-form-input id="exampleInput1"
                        name="InputServer"
                        type="text"
                        required
                        placeholder="請輸入伺服器名稱"
                        :disabled="btn_edit"
                        v-model="serverHost">
          </b-form-input>
          <field-messages name="InputServer" show="$invalid && $submitted" class="text-danger">
            <div slot="required">伺服器名稱為必填</div>
          </field-messages>
        </b-form-group>
        </validate>
        <validate tag="div">
        <b-form-group id="exampleInputGroup2"
                      label="Port"
                      label-for="exampleInput2">
          <b-form-input id="exampleInput2"
                        name="InputPort"
                        type="number"
                        required
                        placeholder="請輸入 Port"
                        :disabled="btn_edit"
                        v-model="serverPort">
          </b-form-input>
          <field-messages name="InputPort" show="$invalid && $submitted" class="text-danger">
            <div slot="required">Port為必填</div>
          </field-messages>
        </b-form-group>
        </validate>
        <validate tag="div">
        <b-form-group id="exampleInputGroup3"
                      label="帳號名稱"
                      label-for="exampleInput3">
          <b-form-input id="exampleInput3"
                        name="InputAccount"
                        type="text"
                        required
                        placeholder="請輸入帳號名稱"
                        :disabled="btn_edit"
                        v-model="userName">
          </b-form-input>
          <field-messages name="InputAccount" show="$invalid && $submitted" class="text-danger">
            <div slot="required">帳號為必填</div>
          </field-messages>
        </b-form-group>
        </validate>
        <validate tag="div">
        <b-form-group id="exampleInputGroup4"
                      label="密碼"
                      label-for="exampleInput4">
          <b-form-input id="exampleInput4"
                        name="InputPassword"
                        type="password"
                        required
                        placeholder="請輸入密碼"
                        :disabled="btn_edit"
                        v-model="password">
          </b-form-input>
          <field-messages name="InputPassword" show="$invalid && $submitted" class="text-danger">
            <div slot="required">密碼為必填</div>
          </field-messages>
        </b-form-group>
        </validate>
    </div>
    </vue-form>
  </div>
</template>

<script>
// for API_URL
import axios from 'axios'
import {API_URL} from '../../store/root.js'
// for 訊息視窗
import miniToastr from 'mini-toastr'
// 功能權限function
import {getFunctionPermission} from '../../js/LoginUserFunction.js'

export default {
  // name: 'HelloWorld',
  data () {
    return {
      btn_edit: true,
      formstate: {}, // 驗證用
      serverHost: '',
      serverPort: '',
      userName: '',
      password: '',
      FunctionPermission: 0, // 功能權限
      queryData: undefined
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F03') // 功能權限 帶入功能代碼
    if (this.FunctionPermission > 0) {
      this.load()
    } else {
      this.$router.push({ name: 'name' })
    }
  },
  methods: {
    load () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/mailserver/query')
        .then((response) => {
          if (response.data.result === '0000') {
            this.serverHost = response.data.data.serverHost
            this.serverPort = response.data.data.serverPort
            this.userName = response.data.data.userName
            this.password = response.data.data.password
            this.queryData = response.data.data
            this.$parent.Loading = false
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
              this.$parent.Loading = false
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    onSubmit: function () {
      if (this.formstate.$invalid) {
      } else {
        this.edit()
      }
    },
    cancel () {
      this.btn_edit = !this.btn_edit
      if (this.queryData !== undefined) {
        this.serverHost = this.queryData.serverHost
        this.serverPort = this.queryData.serverPort
        this.userName = this.queryData.userName
        this.password = this.queryData.password
      }
    },
    edit () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/mailserver/update', {
        serverHost: this.serverHost,
        serverPort: this.serverPort,
        userName: this.userName,
        password: this.password
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.queryData = {
              serverHost: this.serverHost,
              serverPort: this.serverPort,
              userName: this.userName,
              password: this.password
            }
            this.btn_edit = !this.btn_edit
            this.$parent.Loading = false
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
              this.$parent.Loading = false
            }
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.ui-breadcrumb {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/mailServerSetting.vue